

























import Vue from 'vue'
import { DxColumn, DxDataGrid, DxScrolling } from 'devextreme-vue/data-grid'
import { GetFinancialActivityResponse } from '@/types/service-response'
import { GET_PROJECT_REPRINT_ACCOUNTING_RECORDS } from '@/store/action-types'
import { ProjectFinancialActivities } from '@/model/project/ProjectFinancialActivities'

interface ComponentData {
  accountingRecordsList: ProjectFinancialActivities[]
}

export default Vue.extend({
  name: 'ProjectReprintAccountingRecords',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling
  },

  props: {
    belegId: Number
  },

  data (): ComponentData {
    return {
      accountingRecordsList: []
    }
  },

  watch: {
    belegId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.fetchData()
      }
    }
  },

  computed: {

  },

  methods: {
    async fetchData (): Promise<void> {
      const response: GetFinancialActivityResponse = await this.$store.dispatch(GET_PROJECT_REPRINT_ACCOUNTING_RECORDS,  this.belegId)
      if(!response.IsError && response.FinancialActivities) {
        this.accountingRecordsList = ProjectFinancialActivities.createFromResponse(response.FinancialActivities)
      }
    }
  },

  mounted () {
    if(this.belegId) {
      this.fetchData()
    }
  }
})
